module.exports = __webpack_public_path__ + "img/[嘘].92ec1d2e.svg";